import type { FaireProductEntity } from "../../entity_types/product";

export const p_6nms6gdz8d: FaireProductEntity = {
  token: "p_6nms6gdz8d",
  type: "product",
  name: "Magnetic Shopping List, Colorblock",
  brandToken: "b_2io333ig7s",
  brandName: "Ban.do",
  imageUrl: "https://cdn.faire.com/fastly/bb659f5b4901f0627f8b5adec5a577b01aed576dc0649b819f38febe19fb320d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a7156ec58db854eb11544b23194383d3d022f412e085243c76d37be007d9b69d.jpeg",
    "https://cdn.faire.com/fastly/50a272a6c00a0bb55677546f741fab28beea4e76642a01eb8a776013ce900423.jpeg"
  ],
  priceDollars: 5,
  description: "Meal planning can save time and brainpower! This magnetic shopping list pad sticks right to your fridge and includes 52 perforated pages, so you can plan ahead, tear off your list, and shop smarter every week. Functional, cheerful, and a total everyday hero.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n\n• Magnetic backing for easy fridge or file cabinet display\n• Includes 52 perforated sheets—one for every week of the year\n• Perfect for grocery lists, meal planning, and reminders\n• Tear-off pages for grab-and-go convenience\n• Designed in ban.do’s signature bright and helpful style\n\n𝐈𝐝𝐞𝐚𝐥 𝐅𝐨𝐫\n\n• Gift shops and stationery boutiques\n• Home goods and kitchenware retailers\n• Meal planners, busy households, and students\n• Wholesale buyers seeking cute, practical paper goods",
  tags: [],
  msrpDollars: 9.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:32:42.396Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
